/* S1 hero carve: on the first homepage view of a session, the logo mark burns in from where its lines cross.
   The logo <img> is never dimmed or moved (it is the LCP element). Instead a static cover in the markup
   (.mf-logo-cover, shown only while html.mf-carve-pending) paints over the uncut lines; this script shrinks
   each cover line as the burn reaches it, adds the hot trail and sparks, then removes the pending class. */
(function () {
  var root = document.documentElement, KEY = 'mfCarved';
  var cover = document.querySelector('#fv2 .mf-logo-cover');
  function finishFlag() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function release() { root.classList.remove('mf-carve-pending'); finishFlag(); }
  if (!root.classList.contains('mf-carve-pending')) { return; }
  if (!cover || !window.requestAnimationFrame) { release(); return; }

  var START_DELAY_MS = 450, TRACE_MS = 3000, FADE_MS = 700, TRAIL_PX = 170, SPARK_POOL = 18;
  var NS = 'http://www.w3.org/2000/svg';
  var X = [767, 249]; // where the diagonals cross, in logo PNG pixels (1556 x 794)

  function el(tag, attrs, parent) { var e = document.createElementNS(NS, tag); for (var k in attrs) { e.setAttribute(k, attrs[k]); } if (parent) { parent.appendChild(e); } return e; }

  function run() {
    // Cover polylines run from each line's far end towards the crossing, so "uncut" = the first (len - burnt) units.
    var tracks = Array.prototype.map.call(cover.querySelectorAll('.mf-cover-lines polyline'), function (p) {
      var pts = p.getAttribute('points').trim().split(/\s+/).map(function (s) { return s.split(',').map(Number); });
      var segs = [], len = 0;
      for (var i = 1; i < pts.length; i++) { var s = Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]); segs.push(s); len += s; }
      return { el: p, pts: pts, segs: segs, len: len, delay: +(p.getAttribute('data-delay') || 0) };
    });
    var hotG = el('g', { 'class': 'mf-cover-hot', fill: 'none', stroke: '#ff8a3a', 'stroke-width': 24, 'stroke-linecap': 'round' }, cover);
    tracks.forEach(function (t) { t.hot = el('polyline', { points: t.el.getAttribute('points') }, hotG); });
    var sparkG = el('g', { fill: '#ffe2b0' }, cover), sparks = [];
    var headG = el('g', {}, cover), heads = tracks.map(function () {
      return { glow: el('circle', { r: 22, fill: '#ffcf8a', opacity: 0, filter: 'url(#mfCoverSoft)' }, headG), core: el('circle', { r: 8, fill: '#fffaf0', opacity: 0 }, headG) };
    });
    for (var i = 0; i < SPARK_POOL; i++) { sparks.push({ c: el('circle', { r: 0 }, sparkG), x: 0, y: 0, vx: 0, vy: 0, life: 0 }); }
    var speed = Math.max.apply(null, tracks.map(function (t) { return t.delay + t.len; })) / TRACE_MS;

    function pointAt(t, d) {
      for (var i = 0; i < t.segs.length; i++) {
        if (d <= t.segs[i]) { var a = t.pts[i], b = t.pts[i + 1], k = d / t.segs[i]; return [a[0] + (b[0] - a[0]) * k, a[1] + (b[1] - a[1]) * k]; }
        d -= t.segs[i];
      }
      return t.pts[t.pts.length - 1];
    }
    function draw(travel) {
      tracks.forEach(function (t, ti) {
        var burnt = Math.max(0, Math.min(t.len, travel - t.delay)), uncut = t.len - burnt, win = Math.min(burnt, TRAIL_PX);
        t.el.style.visibility = uncut > 0.5 ? 'visible' : 'hidden';
        t.el.style.strokeDasharray = uncut + ' ' + t.len * 2;
        // Trail = the TRAIL_PX just burnt, i.e. starting at the cut point and running back towards the crossing.
        t.hot.style.visibility = win > 1 && burnt < t.len ? 'visible' : 'hidden';
        t.hot.style.strokeDasharray = win + ' ' + t.len * 3; t.hot.style.strokeDashoffset = String(-uncut);
        var hd = heads[ti], live = burnt > 0 && uncut > 0, hp = live ? pointAt(t, uncut) : null;
        [hd.glow, hd.core].forEach(function (c) { if (hp) { c.setAttribute('cx', hp[0]); c.setAttribute('cy', hp[1]); } c.setAttribute('opacity', hp ? (0.8 + Math.random() * 0.2).toFixed(2) : 0); });
        if (burnt > 0 && uncut > 0 && Math.random() < 0.2) {
          var h = pointAt(t, uncut);
          for (var j = 0; j < sparks.length; j++) { var s = sparks[j]; if (s.life <= 0) { s.x = h[0]; s.y = h[1]; s.vx = (Math.random() - 0.5) * 9; s.vy = -2 - Math.random() * 6; s.life = 1; break; } }
        }
      });
    }
    function stepSparks(dt) {
      sparks.forEach(function (s) {
        if (s.life > 0) { s.x += s.vx * dt / 16; s.y += s.vy * dt / 16; s.vy += 0.45 * dt / 16; s.life -= 0.035 * dt / 16; }
        s.c.setAttribute('cx', s.x.toFixed(1)); s.c.setAttribute('cy', s.y.toFixed(1)); s.c.setAttribute('r', s.life > 0 ? (5 * s.life).toFixed(1) : 0);
      });
    }
    var t0 = performance.now(), last = t0, flashed = false;
    function frame(now) {
      var t = now - t0, dt = Math.min(48, now - last); last = now;
      draw(Math.min(t, TRACE_MS) * speed);
      stepSparks(dt);
      if (t >= TRACE_MS && !flashed) { flashed = true; if (img) { img.classList.add('mf-carve-flash'); setTimeout(function () { img.classList.remove('mf-carve-flash'); }, 1100); } }
      hotG.style.opacity = t > TRACE_MS ? String(Math.max(0, 1 - (t - TRACE_MS) / FADE_MS)) : '1';
      if (t < TRACE_MS + FADE_MS) { window.requestAnimationFrame(frame); }
      else { hotG.parentNode.removeChild(hotG); sparkG.parentNode.removeChild(sparkG); headG.parentNode.removeChild(headG); root.classList.remove('mf-carve-pending'); }
    }
    finishFlag();
    draw(0);
    window.requestAnimationFrame(frame);
  }

  var img = document.querySelector('#fv2 .mf-logo');
  var ready = img && img.decode ? img.decode() : Promise.resolve();
  ready.then(function () { setTimeout(run, START_DELAY_MS); }, release);
})();
